export default from './InputEmail'


// WEBPACK FOOTER //
// ./src/components/InputEmail/index.js